/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SectionHistoryResponse
 */
export interface SectionHistoryResponse {
    /**
     * 
     * @type {string}
     * @memberof SectionHistoryResponse
     */
    sectionCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SectionHistoryResponse
     */
    sectionName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SectionHistoryResponse
     */
    startDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SectionHistoryResponse
     */
    endDate?: Date | null;
}

/**
 * Check if a given object implements the SectionHistoryResponse interface.
 */
export function instanceOfSectionHistoryResponse(value: object): value is SectionHistoryResponse {
    return true;
}

export function SectionHistoryResponseFromJSON(json: any): SectionHistoryResponse {
    return SectionHistoryResponseFromJSONTyped(json, false);
}

export function SectionHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionHistoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'sectionCode': json['sectionCode'] === undefined ? undefined : json['sectionCode'] === null ? null : json['sectionCode'],
        'sectionName': json['sectionName'] === undefined ? undefined : json['sectionName'] === null ? null : json['sectionName'],
        'startDate': json['startDate'] === undefined ? undefined : json['startDate'] === null ? null : (new Date(json['startDate'])),
        'endDate': json['endDate'] === undefined ? undefined : json['endDate'] === null ? null : (new Date(json['endDate'])),
    };
}

export function SectionHistoryResponseToJSON(json: any): SectionHistoryResponse {
    return SectionHistoryResponseToJSONTyped(json, false);
}

export function SectionHistoryResponseToJSONTyped(value?: SectionHistoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sectionCode': value['sectionCode'],
        'sectionName': value['sectionName'],
        'startDate': value['startDate'] == null ? value['startDate'] : value['startDate'].toISOString(),
        'endDate': value['endDate'] == null ? value['endDate'] : value['endDate'].toISOString(),
    };
}

